import { useTranslate } from '@tolgee/react';
import { Drawer, DrawerProps } from 'antd';
import ScrollTable from 'components/ScrollTable';
import { formatNumber } from 'utils/numberFormat';

function LogisticsDrawer({
  isVoice,
  isAdvantage,
  problem: { content, cnContent, shipmentProvider },
  ...otherProps
}: DrawerProps & {
  isVoice?: boolean;
  isAdvantage?: boolean;
  problem: ReviewAnalysis.Problem;
}) {
  const { t } = useTranslate();

  const table = (
    <ScrollTable
      size="small"
      rowKey="name"
      dataSource={shipmentProvider}
      columns={[
        {
          key: 'index',
          title: t('排名'),
          render: (_, __, index) => index + 1,
        },
        {
          key: 'name',
          dataIndex: 'name',
          title: t('物流公司'),
        },
        {
          key: 'count',
          dataIndex: 'count',
          title: isVoice ? (isAdvantage ? t('优点评价数') : t('问题评价数')) : t('差评数'),
        },
        {
          key: 'percent',
          dataIndex: 'percent',
          title: t('占比'),
          render: (percent) => formatNumber(Number(percent) / 100, '0.00%'),
        },
      ]}
      pagination={false}
    />
  );

  return (
    <Drawer
      width={462}
      title={`${
        isVoice ? (isAdvantage ? t('优势物流明细') : t('问题物流明细')) : t('差评物流明细')
      } - ${cnContent || content}`}
      {...otherProps}
    >
      {table}
    </Drawer>
  );
}

export default LogisticsDrawer;
